import { routeConstants } from "../constants";
import { checkSegments } from "./util";
import { isUS } from "./locale";

// added in sxen468
export const isInAppWithBiometricSurvey = checkSegments({
  oneOf: [routeConstants.app14DayWebMain, routeConstants.app14DayMain],
});

export const isApp14DayBaseRoute = checkSegments({
  oneOf: [
    routeConstants.app14DayWeb,
    routeConstants.app14Day,
    isInAppWithBiometricSurvey,
  ],
});

export const isAppBaseRoute = checkSegments({
  oneOf: [isApp14DayBaseRoute, routeConstants.appNoTrial],
});

export const isInAppWinback = checkSegments({
  oneOf: [
    routeConstants.app14DayFtWeb,
    routeConstants.app14DayReturning,
    routeConstants.appNoTrialReturning,
  ],
});

export const isInApp = checkSegments({
  oneOf: [isInAppWinback, isAppBaseRoute],
});
export const isUSInAppWinback = checkSegments({
  allOf: [isUS],
  oneOf: [isInAppWinback],
});
export const isInApp14DayiOS = checkSegments({
  oneOf: [
    routeConstants.app14Day,
    routeConstants.app14DayReturning,
    routeConstants.app14DayMain,
  ],
});
